import { capitalize } from '@/domain/common/format'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'

export function PositionListItem({
  token,
  value,
  type,
}: { token: Token; value: NormalizedUnitNumber; type: 'deposit' | 'borrow' }) {
  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center gap-3">
        <TokenIcon token={token} className="w-10" />
        <div>
          <Typography variant="p">{token.name}</Typography>

          <Typography variant="p" className="text-sm text-white/50">
            {type === 'deposit' ? (
              token.format(value, { style: 'compact' })
            ) : (
              <span className="text-white">- {token.formatUSD(value)}</span>
            )}{' '}
            {token.symbol}
          </Typography>
        </div>
      </div>

      <div className="text-right">
        <Typography variant="p">
          {type === 'deposit' ? '+' : '-'} {token.formatUSD(value)}
        </Typography>
        <Typography variant="p" className="text-sm text-white/50">
          {capitalize(type)}
        </Typography>
      </div>
    </div>
  )
}
